
import FInfoIcon from '@/components/atoms/icons/h-info';

export default {
  name: 'FInfoTooltip',

  components: {
    FInfoIcon,
  },

  props: {
    htmlContent: {
      type: String,
      default: '',
    },
    tooltipIconClass: {
      type: String,
      default: 'ml-1',
    },
    color: {
      type: String,
      default: 'white',
    },
    type: {
      type: String,
      default: 'tooltip',
      validator(value) {
        return ['tooltip', 'menu'].includes(value);
      },
    },
    dark: {
      type: Boolean,
    },
    hasError: {
      type: Boolean,
    },
    maxWidth: {
      type: String,
      default: '320px',
    },
  },

  data: () => ({
    show: false,
  }),

  computed: {
    textColor() {
      return this.dark ? 'white--text' : '';
    },
  },
};
